import React from "react";
import messages from "./messages";
import { injectIntl } from "react-intl";
import { Collapse } from "antd";

import Wrapper from "../LandingBlockWrapper/BlockWrapper";

const Panel = Collapse.Panel;

const answers = [
	{
		title: messages.title1,
		list: [
			{
				header: messages["title1.header"],
				content: messages["title1.content"]
			},
			{
				header: messages["title1.header"],
				content: messages["title1.content"]
			},
			{
				header: messages["title1.header"],
				content: messages["title1.content"]
			},
		],
	},
	{
		title: messages.title2,
		list: [
			{
				header: messages["title1.header"],
				content: messages["title1.content"]
			},
			{
				header: messages["title1.header"],
				content: messages["title1.content"]
			},
			{
				header: messages["title1.header"],
				content: messages["title1.content"]
			},
		],
	},
];

const Block = injectIntl(({ answers, intl: { formatMessage } }) => {
	return (
		<Collapse bordered={false}>{
			answers.map((quest, i) => {
				return <Panel header={formatMessage(quest.header)} key={i} className="customPanelStyle">
					<p>{formatMessage(quest.content)}</p>
				</Panel>
			})
		}
		</Collapse>
	);
});

export default injectIntl((props) => {
	const { intl: { formatMessage } } = props;
	return <Wrapper className="Callapse">
		<h2>Frequently Asked Questions</h2>
		{answers.map((item, i) => {
			return <div className="block" key={i}>
				<p className="title">{formatMessage(item.title)}</p>
				<Block key={i} answers={item.list}/>
			</div>
		})
		}
	</Wrapper>
});



// WEBPACK FOOTER //
// ./src/components/FAQ/FAQ.js